import template from './connectCall.template.html';
import templateAddAsNote from './addToTicketAsNote.template.html';

export default {
  template,
  bindings: {
    onCall: '&'
  },
controller: class controller {
    constructor(
      $timeout,
      $filter,
      $rootScope,
      $mdDialog,
      $window,
      authenticationService,
      eventService,
      callService,
      callsService,
      scriptsService,
      workflowsService,
      notesService,
      ticketsService,
      uiService,
      TICKET
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = null;
      ctrl.currentAccount = null;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;

      ctrl.contact = null;
      ctrl.sender = '';
      ctrl.senders = [];
      ctrl.phone = '';
      ctrl.phoneIncoming = '';
      ctrl.scripts = [];

      ctrl.isInitializing = false;
      ctrl.isReady = false;

      ctrl.isOutgoingCall = false;
      ctrl.isOutgoingRinging = false;
      ctrl.isOutgoingAnswered = false;
      ctrl.isIncomingCall = false;
      ctrl.isIncomingRinging = false;
      ctrl.isIncomingAnswered = false;
      ctrl.isCallMuted = false;
      ctrl.isCallRecording = false;
      ctrl.currentCallStatus = '';
      ctrl.currentCallModifier = '';

      ctrl.hasErrors = false;
      ctrl.currentErrorDescription = '';

      ctrl.currentCall = null;
      ctrl.currentNote = '';
      ctrl.isEditingNote = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        if (authenticationService.isAuthenticated()) {
          ctrl.currentOrganization = $rootScope.CurrentOrganization;
          ctrl.currentAccount = $rootScope.CurrentAccount;
          ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
          ctrl.currentLocale = $rootScope.CurrentLocale();
          ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
          ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat();
          ctrl.senders = [];

          ctrl.startPlivo();

          callService.resetCurrent();
          callsService
            .getAvailable({ isAnswered: true, isActive: false, limitTo: 25 })
            .then((data) => {
              ctrl.archive = _.reverse(data);
            });

          const assignedPhones = ctrl.currentOrganization.getPhonesForOwner(
            ctrl.currentAccount.id
          );

          if (assignedPhones && assignedPhones.length) {
            for (let i = 0; i < assignedPhones.length; i += 1) {
              ctrl.senders.push({
                id: `${ctrl.currentAccount.id}-ph${i}`,
                name: ctrl.currentAccount.getName(),
                phone: assignedPhones[i].number
              });
            }
          }

          ctrl.switchSender(ctrl.currentAccount.id);
          scriptsService.getAvailable({ isActive: true }).then((scripts) => {
            ctrl.scripts = scripts;
          });
        }
      };
      ctrl.refresh = () => {
        $timeout(() => {
          ctrl.refreshCalls();
        }, 1000);
        $timeout(() => {
          ctrl.refreshCalls();
        }, 3500);
        $timeout(() => {
          ctrl.refreshCalls();
        }, 7500);
      };
      ctrl.refreshCalls = () => {
        callsService.clearCache();
        callsService
          .getAvailable({ isAnswered: true, isActive: false, limitTo: 25 })
          .then((data) => {
            if (data.length && data[data.length - 1]) {
              const lastCall = data[data.length - 1];
              const archivedCall = _.find(ctrl.archive, (call) => {
                return call.id === lastCall.id;
              });
              if (archivedCall && archivedCall.id) {
                uiService.scopeApply(() => {
                  ctrl.archive.splice(ctrl.archive.indexOf(archivedCall), 1, lastCall);
                });
              } else {
                ctrl.archive.push(lastCall);
                uiService.elementContentScroll('callContent');
              }
            }
          });
      };
      ctrl.appendPhone = (number) => {
        if (!ctrl.isOutgoingAnswered && !ctrl.isIncomingAnswered) {
          ctrl.phone = `${ctrl.phone}${number}`;
        } else {
          callService.dtmf(number);
        }
      };
      ctrl.erasePhone = (whole) => {
        ctrl.phone = ctrl.phone.slice(0, whole ? ctrl.phone.length : -1);
      };
      ctrl.toggleCallScript = (script) => {
        if (!script) {
          ctrl.script = null;
        } else if (ctrl.script && script.id === ctrl.script.id) {
          ctrl.script = null;
        } else {
          ctrl.script = script;
        }
      };
      ctrl.cancelNote = () => {
        ctrl.currentNote = '';
        ctrl.currentCall = null;
        ctrl.isEditingNote = false;
        uiService.elementContentScroll('callContent');
      };
      ctrl.saveNote = () => {
        if (ctrl.currentCall && ctrl.currentCall.id) {
          ctrl.currentCall.note = ctrl.currentNote;
          callService.updateCall({ id: ctrl.currentCall.id, note: ctrl.currentNote });
          callsService.clearCache();
        } else {
          callService.updateCall({ id: callService.getCurrent(), note: ctrl.currentNote });
          callsService.clearCache();
        }
        ctrl.currentNote = '';
        ctrl.currentCall = null;
        ctrl.isEditingNote = false;
        uiService.elementContentScroll('callContent');
      };
      ctrl.editNote = (note, call) => {
        if (note) {
          ctrl.currentNote = note;
        }
        if (call) {
          ctrl.currentCall = call;
        }
        ctrl.isEditingNote = true;
      };
      ctrl.showSaveToNoteDialog = (call) => {
        $mdDialog
          .show({
            locals: {
              call
            },
            template: templateAddAsNote,
            controllerAs: '$ctrl',
            controller: function addToTicketAsNoteController() {
              'ngInject';
              const self = this;
              self.isLoading = true;
              self.idWorkflow = null;
              self.availableWorkflows = [];
              self.idTicket = null;
              self.availableTickets = [];
              workflowsService.getAvailable({ isActive: true }).then((workflows) => {
                self.availableWorkflows = workflows;
                self.availableTickets = [];
                self.isLoading = false;
              });
              self.getTickets = () => {
                self.isLoading = true;
                self.availableTickets = [];
                ticketsService
                  .getByWorkflow({
                    idWorkflow: self.idWorkflow,
                    fields: TICKET.FIELDS.DROPDOWN
                  })
                  .then((tickets) => {
                    self.availableTickets = _.chain(tickets).sortNatural('name').value();

                    self.isLoading = false;
                  });
              };
              self.confirmDialog = () => {
                $mdDialog.hide({ idWorkflow: this.idWorkflow, idTicket: this.idTicket });
              };
              self.cancelDialog = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((dialogResult) => {
            callService
              .addToTicketAsNote({
                idCall: call.id,
                idWorkflow: dialogResult.idWorkflow,
                idTicket: dialogResult.idTicket
              })
              .then((result) => {
                if (result && result.status) {
                  notesService.clearCache();
                  callsService.clearCache();
                  // eslint-disable-next-line no-param-reassign
                  call.isSaved = true;
                  uiService.toast({
                    text: {
                      p1: 'Saved call to',
                      p2: 'deal',
                      p3: 'as a note'
                    }
                  });
                }
              });
          });
      };

      /*
       * Call Control Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.placeCall = () => {
        callService.resetCurrent();
        if (!ctrl.phone) {
          uiService.toast({
            text: {
              p1: 'Callee',
              p2: 'phone number',
              p3: 'is required'
            },
            warn: true
          });
        } else {
          callService
            .start({
              source: ctrl.getCurrentSender().phone,
              destination: ctrl.phone,
              idWorkflow: null,
              idTicket: null,
              idContact: ctrl.contact && ctrl.contact.id ? ctrl.contact.id : null,
              contactName: null
            })
            .then((result) => {
              if (result.status) {
                ctrl.editNote();
              }
            });
        }
      };
      ctrl.answerCall = () => {
        callService.answer().then((result) => {
          if (result.status) {
            ctrl.editNote();
          }
        });
        ctrl.currentCallStatus = 'In progress ...';
        ctrl.currentCallModifier = 'Speaking with caller';
        ctrl.onCall({ isActive: true });
      };
      ctrl.rejectCall = () => {
        ctrl.currentCallStatus = 'Rejecting ...';
        ctrl.currentCallModifier = 'Disconnecting inbound call';
        callService.reject();
      };
      ctrl.hangupCall = () => {
        ctrl.currentCallStatus = 'Hanging-up ...';
        ctrl.currentCallModifier = `Terminating ${ctrl.isOutgoingCall}`
          ? 'outbound'
          : 'inbound call';
        callService.hangup();
      };
      ctrl.recordCall = () => {
        ctrl.currentCallModifier = ctrl.isCallMuted
          ? '[REC] Call is currently muted'
          : '[REC] Speaking with caller';
        ctrl.isCallRecording = !ctrl.isCallRecording;
        callService.record();
      };
      ctrl.toggleMuteCall = () => {
        if (!ctrl.isCallMuted) {
          ctrl.currentCallModifier = ctrl.isCallRecording
            ? '[REC] Call is currently muted'
            : 'Call is currently muted';
          ctrl.isCallMuted = true;
          callService.mute();
        } else {
          ctrl.currentCallModifier = ctrl.isCallRecording
            ? '[REC] Speaking with caller'
            : 'Speaking with caller';
          ctrl.isCallMuted = false;
          callService.unmute();
        }
      };
      ctrl.sendDtmf = (digit) => {
        callService.dtmf(digit);
      };

      /*
       * Events
       * --------------------------------------------------------------------------------
       */
      ctrl.onPastePhone = ($event) => {
        $event.preventDefault();
        const pastedValue = $event.originalEvent.clipboardData.getData('text/plain');
        ctrl.phone = pastedValue.onlyNumbers();
      };
      ctrl.onTypingPhone = ($event) => {
        if (
          _.isNaN(String.fromCharCode($event.keyCode)) ||
          String.fromCharCode($event.keyCode) === ' '
        ) {
          $event.preventDefault();
        }
      };

      /*
       * Call Control Events
       * --------------------------------------------------------------------------------
       */
      ctrl.startPlivo = () => {
        const options = {
          debug: 'OFF',
          permOnClick: true,
          enableTracking: true
        };

        $window.plivoWebSdk = new window.Plivo(options);

        ctrl.initPlivoListeners();

        if (authenticationService.isAuthenticated()) {
          callService.login();
        } else {
          callService.logout();
        }
        uiService.scopeApply(() => {
          ctrl.isInitializing = true;
          ctrl.isReady = false;
        });
      };

      ctrl.initPlivoListeners = () => {
        $window.plivoWebSdk.client.on('onLogin', () => {
          uiService.scopeApply(() => {
            ctrl.isInitializing = true;
            ctrl.isReady = true;
          });
        });
        $window.plivoWebSdk.client.on('onWebrtcNotSupported', () => {
          uiService.scopeApply(() => {
            ctrl.hasErrors = true;
            ctrl.currentErrorDescription = 'WebRTC is not supported in this browser.';
          });
        });
        $window.plivoWebSdk.client.on('onMediaPermission', (result) => {
          uiService.scopeApply(() => {
            ctrl.hasErrors = !result;
            ctrl.currentErrorDescription = 'Media permissions in browser are required.';
          });
        });
        $window.plivoWebSdk.client.on('onLoginFailed', () => {
          uiService.scopeApply(() => {
            ctrl.hasErrors = true;
            ctrl.currentErrorDescription = 'Cannot login to telephony center.';
          });
        });
        $window.plivoWebSdk.client.on('onLogout', () => {});
        $window.plivoWebSdk.client.on('onCalling', () => {
          uiService.scopeApply(() => {
            ctrl.isOutgoingCall = true;
            ctrl.isOutgoingRinging = false;
            ctrl.isOutgoingAnswered = false;
            ctrl.isIncomingCall = false;
            ctrl.isIncomingRinging = false;
            ctrl.isIncomingAnswered = false;
            ctrl.isCallMuted = false;
            ctrl.isCallRecording = false;
            ctrl.currentCallStatus = 'Dialling ...';
            ctrl.currentCallModifier = 'Establishing outbound call';
          });
          ctrl.onCall({ isActive: true });
        });
        $window.plivoWebSdk.client.on('onCallRemoteRinging', () => {
          uiService.scopeApply(() => {
            ctrl.isOutgoingCall = true;
            ctrl.isOutgoingRinging = true;
            ctrl.isOutgoingAnswered = false;
            ctrl.isIncomingCall = false;
            ctrl.isIncomingRinging = false;
            ctrl.isIncomingAnswered = false;
            ctrl.isCallMuted = false;
            ctrl.isCallRecording = false;
            ctrl.currentCallStatus = 'Ringing ...';
            ctrl.currentCallModifier = 'Waiting for callee to answer';
          });
        });
        $window.plivoWebSdk.client.on('onCallAnswered', () => {
          uiService.scopeApply(() => {
            ctrl.isOutgoingCall = true;
            ctrl.isOutgoingRinging = true;
            ctrl.isOutgoingAnswered = true;
            ctrl.isIncomingCall = false;
            ctrl.isIncomingRinging = false;
            ctrl.isIncomingAnswered = false;
            ctrl.isCallMuted = false;
            ctrl.isCallRecording = false;
            ctrl.currentCallStatus = 'In progress ...';
            ctrl.currentCallModifier = 'Speaking with callee';
          });
        });
        $window.plivoWebSdk.client.on('onCallTerminated', () => {
          uiService.scopeApply(() => {
            ctrl.currentCallStatus = 'Disconnecting ...';
            ctrl.currentCallModifier = 'Terminating call';
            $timeout(() => {
              ctrl.isOutgoingCall = false;
              ctrl.isOutgoingRinging = false;
              ctrl.isOutgoingAnswered = false;
              ctrl.isIncomingCall = false;
              ctrl.isIncomingRinging = false;
              ctrl.isIncomingAnswered = false;
              ctrl.isCallMuted = false;
              ctrl.isCallRecording = false;
              ctrl.onCall({ isActive: false });
            }, 2500);
          }, 500);
          ctrl.refresh();
        });
        $window.plivoWebSdk.client.on('onCallFailed', (cause) => {
          uiService.scopeApply(() => {
            ctrl.currentCallStatus = 'Disconnecting ...';
            ctrl.currentCallModifier = `Call failed (${cause.toUpperCase()})`;
            $timeout(() => {
              ctrl.isOutgoingCall = false;
              ctrl.isOutgoingRinging = false;
              ctrl.isOutgoingAnswered = false;
              ctrl.isIncomingCall = false;
              ctrl.isIncomingRinging = false;
              ctrl.isIncomingAnswered = false;
              ctrl.isCallMuted = false;
              ctrl.isCallRecording = false;
              ctrl.onCall({ isActive: false });
            }, 2500);
          }, 500);
          ctrl.refresh();
        });

        $window.plivoWebSdk.client.on('onIncomingCall', (accountName, extraHeaders) => {
          const incomingPhoneNumber = accountName.replace('@phone.plivo.com', '');

          ctrl.phoneIncoming =
            incomingPhoneNumber !== '1000000000' ? incomingPhoneNumber : 'anonymous';
          callService.resetCurrent();
          callService.receive({
            source: ctrl.phoneIncoming,
            uuid: extraHeaders['X-Ph-Calluuid']
          });
          eventService.connectCallReceived();
          uiService.scopeApply(() => {
            ctrl.currentCallStatus = `${ctrl.phoneIncoming.formatAsPhone()} calling ...`;
            ctrl.currentCallModifier = 'Waiting for you to answer';
            ctrl.isIncomingCall = true;
            ctrl.isIncomingRinging = true;
            ctrl.isIncomingAnswered = false;
          });
        });
        $window.plivoWebSdk.client.on('onIncomingCallCanceled', () => {
          ctrl.currentCallStatus = 'Rejecting ...';
          ctrl.currentCallModifier = 'Disconnecting inbound call';
          uiService.scopeApply(() => {
            ctrl.currentCallStatus = '';
            ctrl.currentCallModifier = '';
            ctrl.isIncomingCall = false;
            ctrl.isIncomingRinging = false;
            ctrl.isIncomingAnswered = false;
          }, 500);
        });
      };

      /*
       * Helper Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.switchSender = (idSender) => {
        ctrl.sender = idSender;
      };
      ctrl.getCurrentSender = () => {
        return ctrl.getSender(ctrl.sender);
      };
      ctrl.getSender = (idSender) => {
        return $filter('filter')(ctrl.senders, { id: idSender })[0];
      };
      ctrl.formatTime = (time) => {
        return `${moment
          .utc(time, 'X')
          .format($rootScope.CurrentDateFormatPrimary())} ${moment
          .utc(time)
          .format(ctrl.currentTimeFormat)}`;
      };

      /*
       * Broadcast Listeners
       * --------------------------------------------------------------------------------
       */
      eventService.onConnectCall((args) => {
        ctrl.contact = args.contact;
        ctrl.phone = ctrl.contact.getPhone().onlyNumbers();
      });
      eventService.onCredentialsChanged(() => {
        ctrl.initialize();
      });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = () => {};
    }
  }
};
